<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >

  

  <b-modal 
    v-if="toEditOption !== '' || priceManagement"
    v-model="showPopup"
          centered
          :modal-class="popupModalClass"
          :dialog-class="popupDialogClass"
          :content-class="popupContentClass"
          :body-class="popupBodyClass"
          :hide-footer= "true"
          :size="popupSize"
          title="" header-class="app-popup-header"
          >
          <div v-if="toEditOption" class="managerPopup">
            <div class="managerPopup-top">
              <div>
                <h3 class="managerPopup-title">{{ managerPopupTitle }}</h3>
                <div class="managerPopup-subtitle">{{ managerPopupSubtitle }}</div>
              </div>
            </div>
            <div class="managerPopup-card">
              <Opts :PID="toEditOption" TYPE="DD"></Opts>
            </div>
          </div>

          <div v-if="priceManagement" class="pricePopup">
            <div class="pricePopup-top">
              <div>
                <h3 class="pricePopup-title">Mise à jour des prix</h3>
                <div class="pricePopup-subtitle">{{ filtredListitems.length }} service(s) disponibles</div>
              </div>
              <div class="pricePopup-actions">
                <div class="pricePopup-field">
                  <label>Type</label>
                  <select v-model="updPriceType" class="form-control custom-select">
                    <option value=1>Augmentation</option>
                    <option value=-1>Diminution</option>
                  </select>
                </div>
                <div class="pricePopup-field">
                  <label>Taux</label>
                  <base-input
                    placeholder="Taux"
                    v-model="updPrice"
                    type="num"
                    :range="rangePrice"
                    :error="errorCtrl"
                  >
                  </base-input>
                </div>
                <b-button class="pricePopup-apply" variant="success" @click="setUpdPrice();showPopup = false; priceManagement = false">
                  Appliquer
                </b-button>
              </div>
            </div>

            <div class="priceTableWrap">
              <table class="priceTable">
                <thead>
                  <tr>
                    <th class="priceTable-check">
                      <b-icon icon="check-square" style="color: black" scale="1" @click="filtredListitems = filtredListitems.map(e => { return {...e, selected: true}})"></b-icon>
                    </th>
                    <th>Produit</th>
                    <th>Prix de vente</th>
                    <th>Nouveau prix</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(_item, idx) in filtredListitems"
                    :key="idx"
                  >
                    <td class="priceTable-check">
                      <b-icon v-if="!_item.selected" icon="check-square" style="color: #CCC" scale="1" @click="_item.selected = true"></b-icon>
                      <b-icon v-if="_item.selected" icon="check-square" style="color: green" scale="1" @click="_item.selected = false"></b-icon>
                    </td>
                    <td>{{_item.name}}</td>
                    <td>{{ formatMoney(_item.prixV) }}</td>
                    <td><b>{{ calculatePrice(_item)}}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
  </b-modal>
  <div :class="styleHeader">
  <div class="row subMenu" v-if="!__isLightMode">
    <b-button size="sm" variant="danger" style="float: right; margin: 5px" :class="{ activeFilterButton: showFilter }" @click.stop="toggleFilterPanel()">Filtrer</b-button>
    <b-button size="sm" variant="primary" class="alwaysBlueAddButton" style="float: right; margin: 5px"  @click="dispatchAdd()">+ service</b-button>
    <b-button size="sm" variant="primary" style="float: right; margin: 5px" @click="showPopup = true; toEditOption = '676c8c53590157a748c9c8b8'">+ catégorie</b-button>
    <b-button size="sm" variant="success" style="float: right; margin: 5px" @click="showPopup = true; priceManagement = true">MAJ prix</b-button>
  </div>

    <FilterDrawerShell
      :show="__editMode === false && showFilter"
      title="Filtres services"
      :count="filtredListitems.length"
      @close="closeFilterPanel"
    >
      <template #sorts>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isDate.state)" icon="check-square-fill" @click="sortFiltre.isDate.state = !sortFiltre.isDate.state"></b-icon>
          <span>Date</span>
          <b-icon class="redColor" v-if="sortFiltre.isDate.state" icon="recycle" @click="sortFiltre.isDate.isUp = !sortFiltre.isDate.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isName.state)" icon="check-square-fill" @click="sortFiltre.isName.state = !sortFiltre.isName.state"></b-icon>
          <span>Nom</span>
          <b-icon class="redColor" v-if="sortFiltre.isName.state" icon="recycle" @click="sortFiltre.isName.isUp = !sortFiltre.isName.isUp"></b-icon>
        </div>
        <div class="sortItem">
          <b-icon :class="getIsActifSort(sortFiltre.isActivated.state)" icon="check-square-fill" @click="sortFiltre.isActivated.state = !sortFiltre.isActivated.state"></b-icon>
          <span>Etat</span>
          <b-icon class="redColor" v-if="sortFiltre.isActivated.state" icon="recycle" @click="sortFiltre.isActivated.isUp = !sortFiltre.isActivated.isUp"></b-icon>
        </div>
      </template>

      <div class="filterField">
        <label>Référence</label>
        <base-input
          placeholder="Filtre reference"
          v-model="filterContainer.keySearchRef"
          type="string"
        >
        </base-input>
      </div>

      <div class="filterField">
        <label>Désignation</label>
        <base-input
          placeholder="Filtre Désignation"
          v-model="filterContainer.keySearchDes"
          type="string"
        >
        </base-input>
      </div>

      <div class="filterField">
        <label>Catégorie</label>
        <selector
          v-if="toEditOption !== '676c8c53590157a748c9c8b8'"
          _id="676c8c53590157a748c9c8b8"
          :_editable="true"
          :_asFilter="true"
          :_initFn="setCatData"
          :_parentItem="filterContainer"
          _warpper="filter_catID"
        ></selector>
      </div>

      <div class="filterInlineFields">
        <div class="filterField" v-if="!__isLightMode">
          <label>Prix R</label>
          <base-input
            placeholder="Prix R"
            v-model="filterContainer.keySearchPrixR"
            type="number"
          >
          </base-input>
        </div>

        <div class="filterField" v-if="!__isLightMode">
          <label>Prix V</label>
          <base-input
            placeholder="Prix V"
            v-model="filterContainer.keySearchPrixV"
            type="number"
          >
          </base-input>
        </div>
      </div>
    </FilterDrawerShell>
  </div>

    <div v-if="__isLightMode" class="lightSearchBar">
      <div class="lightSearchBar-meta">
        <div class="lightSearchBar-title">Recherche service</div>
        <div class="lightSearchBar-count">
          {{ filtredListitems.length }} resultat<span v-if="filtredListitems.length > 1">s</span>
        </div>
      </div>
      <base-input
        v-model="filterContainer.keySearchLight"
        placeholder="Nom, ref, categorie..."
        type="string"
      >
      </base-input>
    </div>

    <div :class="getMainPanel">
      <div
        :class="styleSublisteMode + isCurrent(index === showList)"
        v-for="(item, index) in filtredListitems"
        :key="index"
        :style=""
        v-if="__idxOnEdition === -1 || __idxOnEdition === index"
      >
      <div class="lightCatalogCard" v-if="__isLightMode">
        <button
          type="button"
          class="lightCatalogAction"
          title="Ajouter au document"
          @click="onSelect(item)"
        >
          <b-icon icon="plus-lg" aria-hidden="true"></b-icon>
        </button>

        <div class="lightCatalogThumb">
          <img :src="getTof(item.pic)" alt="" class="lightCatalogThumbImg" />
        </div>

        <div class="lightCatalogBody">
          <div class="lightCatalogTop">
            <div class="lightCatalogRef">{{ item.ref || "Sans reference" }}</div>
            <div class="lightCatalogKind">Service</div>
          </div>
          <div class="lightCatalogTitle">{{ item.name }}</div>
          <div class="lightCatalogMeta">
            <span>{{ item.catID || "Catégorie" }}</span>
            <span v-if="item.marqueID">{{ item.marqueID }}</span>
          </div>
        </div>

        <div class="lightCatalogPrice">
          <div class="lightCatalogPriceLabel">PUV</div>
          <div class="lightCatalogPriceValue">{{ formatMoney(item.prixV) }}</div>
        </div>
      </div>


        <div class="row" v-if="!__isLightMode">
          <div class="col-md-1 ">
            
            
            <div style="width: 100%">
            
            </div>

            <div class="pic"><img :src="getTof(item.pic)" style="width: 40px; height: 40px" /></div>
          </div>

          <div class="col-md-4 ">
            <em>{{ item.ref }}</em> <br>
            <b>{{ item.name }}</b><br>
            <em style="font-size: 10px;" v-if="item.desc">{{ item.desc.substr(1,60) }}...</em> 
          </div>
          
          <div class="col-md-2 ">
            {{ item.catID }} <br>
           
          </div>


          <div class="col-md-3 ">
            PUV : <b style="color: green">{{ formatMoney(item.prixV) }}</b> HT<br>
            <span style="font-size:10px">PUR : <em style="color: red">{{ formatMoney(item.prixA) }}</em> HT</span>
          </div>



          <div class="col-md-2 ">
          <div class="menu" v-if="__idxOnEdition !== index && showMenu == index">
          <ico-btn
            size="p"
            type="simple"
            icone="gear-fill"
            :cb="
              () => {
                dispatchEdit(item._id);
              }
            "
          ></ico-btn>
          <ico-btn
            size="p"
            type="warning"
            icone="trash"
            :cb="
              () => {
                dispatchDelete(item._id);
              }
            "
          ></ico-btn>
          
          <ico-btn size="p" type="toggleOn" custom="orange" icone="eye-slash-fill" v-if=" item.isActive == true" :cb="()=>{dispatchDesactive(item._id)}"></ico-btn>
        <ico-btn size="p" type="toggleOff" icone="eye-fill" v-if=" item.isActive == false" :cb="()=>{dispatchActive(item._id)}"></ico-btn>
          
        <ico-btn
          size="p"
          type="simple"
          icone="list-check"
          :cb="
            () => {
              //showCmds = item._id;
            }
          "
        ></ico-btn>

          <ico-btn
            size="p"
            type="toggleOn"
            icone="reply-fill"
            :cb="
              () => {
                toggleMenu(index);
              }
            "
          ></ico-btn>
        </div>
        <div
          v-if="__idxOnEdition !== index && showMenu != index "
          style="float: right"
        >
          <b-icon
            icon="gear-fill"
            class="inlineOptionTrigger"
            :class="getIsActif(item.isActive === true || item.isActive===1)"
            aria-hidden="true"
            @click="toggleMenu(index)"
          ></b-icon>


        </div>
          </div>
        </div>
       


        


        


      </div>
    </div>
  </b-overlay>
</template>
<script>
import Opts from '@/pages/opts/index';
import FilterDrawerShell from "@/components/FilterDrawerShell.vue";
export default {
  components: {
    Opts,
    FilterDrawerShell
  },
  props: {
    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },

    __devisIDs: {
      type: Array,
      default: () => {
        return [];
      },
    },

    
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    
    __isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    
    __onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      filterContainer: { keySearchRef: "", keySearchDes: "", keySearchLight: "", keySearchStock: "", keySearchPrixR: "", keySearchPrixV: "", filter_catID: "", filter_marqueID : "" },
      structure: { vCat: [], vMarque: [] },
      showPopup:null,
      showMenu: -1,
      showList: -1,
      showFilter: false,
      toEditOption: '',
      filtredListitems: [],
      selectionMode: false,
      priceManagement: false,
      updPrice: 0,
      errorCtrl: [],
      updPriceType:1,
      rangePrice: {min:0, max:100},
      sortFiltre: {
        isDate: {state: false, isUp: true },
        isName:  {state: false, isUp: true },
        isActivated:  {state: false, isUp: true },
      }
    };
  },
  methods: {
    normalizeSearchValue(value) {
      return String(value || "").trim().toLowerCase();
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(3);
    },

    onSelect(itm) {
      this.$props.__onSelect(itm)
    },

    calculatePrice(itm) {
      var newPrice = itm.prixV;
      if(itm.selected) {
        itm.newPrice = Number(newPrice) + Number((newPrice / 100) * this.updPrice * this.updPriceType)
        return itm.newPrice.toFixed(3)
      }
      return ''
    },

    filtredList() {
      var ret = Array.isArray(this.__list) ? [...this.__list] : [];
      const lightSearch = this.normalizeSearchValue(this.filterContainer.keySearchLight);

      if (lightSearch) {
        ret = ret.filter((e) => {
          const searchableParts = [
            e.name,
            e.ref,
            e.catID,
            e.marqueID,
            e.desc,
          ];

          return searchableParts.some((value) =>
            this.normalizeSearchValue(value).includes(lightSearch)
          );
        });
      }

      if (this.filterContainer.keySearchDes)
        ret = ret.filter((e) =>
        e.name && e.name.includes(this.filterContainer.keySearchDes)
        );

      if (this.filterContainer.keySearchRef)
      ret = ret.filter((e) =>
      e.ref && e.ref.includes(this.filterContainer.keySearchRef)
      );

      if (this.filterContainer.keySearchStock)
      ret = ret.filter((e) =>
      e.stock && e.stock === Number(this.filterContainer.keySearchStock) || e.stock === (this.filterContainer.keySearchStock)
      );

      if (this.filterContainer.keySearchPrixV)
      ret = ret.filter((e) =>
      e.prixV && e.prixV === Number(this.filterContainer.keySearchPrixV)
      );

      if (this.filterContainer.keySearchPrixR)
      ret = ret.filter((e) =>
      e.prixR && e.prixR === Number(this.filterContainer.keySearchPrixR)
      );

      if (this.filterContainer.filter_catID)
        ret = ret.filter((e) => e.catID === this.filterContainer.filter_catID);
      
      if (this.filterContainer.filter_marqueID)
        ret = ret.filter((e) => e.marqueID === this.filterContainer.filter_marqueID);
      
      this.selectionMode = ret.length !== (Array.isArray(this.__list) ? this.__list.length : 0)
      ret = ret.map(e => {
        return {
          ...e, 
          selected: false
        }
      });

      if(this.sortFiltre.isDate.state === true) {
        if(this.sortFiltre.isDate.isUp)
          ret = ret.sort((a, b) => a.createdAt > b.createdAt);
        else
          ret = ret.sort((a, b) => a.createdAt < b.createdAt);
      }

        
      if(this.sortFiltre.isName.state === true) {
        if(this.sortFiltre.isName.isUp)
          ret = ret.sort((a, b) => String(a.name).localeCompare(String(b.name)));
        else
          ret = ret.sort((a, b) => String(b.name).localeCompare(String(a.name)));
      }



      if(this.sortFiltre.isActivated.state === true) {
        
        if(this.sortFiltre.isActivated.isUp)
          ret = ret.filter((a) => a.isActive === 1 || a.isActif === true);
        else
          ret = ret.filter((b) => b.isActive === 0 || b.isActif === false);
      }

      if(this.$props.__isLightMode) {
        ret = ret.filter((a) => !this.$props.__devisIDs.includes(a._id));
      }
      this.filtredListitems = ret;
      //return ret;
    },

    setCatData(list) {
      this.structure.vCat = list;
    },

    setMarqueData(list) {
      this.structure.vMarque = list;
    },

    isCurrent(current) {
      if (this.showList !== -1) return current ? "  actif" : " flowted";
      return "";
    },

    toggleMenu(index) {
      if (this.showMenu != index) {
        this.showMenu = index;
      } else {
        this.showMenu = -1;
      }
    },

    toggleList(index) {
      if (this.showList != index) {
        this.showList = index;
      } else {
        this.showList = -1;
      }
    },

    setUpdPrice() {
      this.filtredListitems.map(e => {
        if(e.selected && e.newPrice) {
          this.$parent.updPriceAction(e);
        }
      })
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },

    dispatchDelete(idx) {
      this.$bvModal
        .msgBoxConfirm("Veuillez confirmer la suppression.", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Confirmer",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: false,
        })
        .then((value) => {
          if (value) {
            this.$parent.deleteAction(idx);
          }
        });
    },

    dispatchActive(idx) {
      this.$parent.toggleActivateAction(idx,1);
    },

    dispatchDesactive(idx) {
      this.$parent.toggleActivateAction(idx,0);
    },

    dispatchAdd() {
      this.$parent.addAction();
    },

    toggleFilterPanel() {
      this.showFilter = !this.showFilter;
    },

    closeFilterPanel() {
      this.showFilter = false;
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/catalogue/No-Image.jpg');
      // return "http://localhost:5000/uploads/" + c.split("/uploads/")[1];
      // return "./uploads/" + c.split("/uploads/")[1];
    },

    getIsActif(isActif) {
      return isActif === true
        ? ""
        : "redColor";
    },

    getIsActifSort(isActif) {
      return isActif === false
        ? "grayColor"
        : "greenColor";
    },
  },
  watch: {
    __isOnLoad: function () {},
  },
  computed: {
    popupModalClass() {
      return (this.priceManagement || this.toEditOption)
        ? "app-popup-shell price-popup-shell"
        : "app-popup-shell";
    },

    popupDialogClass() {
      return (this.priceManagement || this.toEditOption)
        ? "app-popup-dialog price-popup-dialog"
        : "app-popup-dialog";
    },

    popupContentClass() {
      return (this.priceManagement || this.toEditOption)
        ? "app-popup-content price-popup-content"
        : "app-popup-content";
    },

    popupBodyClass() {
      return (this.priceManagement || this.toEditOption)
        ? "app-popup-body price-popup-body"
        : "app-popup-body";
    },

    popupSize() {
      return "xl";
    },

    managerPopupTitle() {
      if (this.toEditOption === '676c8c53590157a748c9c8b8') {
        return 'Gestion des catégories';
      }
      return 'Gestion des options';
    },

    managerPopupSubtitle() {
      if (this.toEditOption === '676c8c53590157a748c9c8b8') {
        return 'Ajoutez, modifiez et organisez les catégories de services.';
      }
      return 'Administration des options disponibles pour les services.';
    },

    styleHeader() {
      return (this.$props.__isLightMode) ? 'row lightHeader' : 'row pageHeader';
    },

    styleSublisteMode() {
      return this.__editMode !== true
        ? (this.$props.__isLightMode)
          ? "lightMode col-md-12"
          : "listeMode serviceGridItem col-xl-3 col-lg-3 col-md-6 col-sm-12"
        : "editMode col-md-12";
    },

    getMainPanel() {
      if(this.showPopup === false) {
        this.toEditOption = '';
        this.priceManagement = false;
      }
      return (this.$props.__isLightMode) ? '' : "row mainPanelWithoutFilter";
    },
  },
  mounted() {
    setTimeout(()=>this.filtredList(),400)
  },

  watch: {
    __isOnLoad: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList __isOnLoad")
        this.filtredList()
      },
    },
    __list: {
      deep: true,
      handler() {
        this.filtredList()
      },
    },
    __idxOnEdition: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValueList __idxOnEdition")
        this.filtredList()
      },
    },
    filterContainer: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue filterContainer")
        this.filtredList()
      },
    },
    sortFiltre: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue sortFiltre")
        this.filtredList()
      },
    },
    $props: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("newValue devisIDs")
        this.filtredList()
      },
    },
  },
};
</script>
<style scoped>
:deep(.price-popup-shell .modal-dialog) {
  max-width: 980px !important;
}

:deep(.price-popup-content) {
  border-radius: 28px !important;
  background: linear-gradient(180deg, #f4f7fb 0%, #edf2f7 100%) !important;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.24) !important;
}

:deep(.price-popup-body) {
  padding: 14px 18px 20px !important;
}

.pricePopup {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.pricePopup-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
}

.pricePopup-title {
  margin: 0 0 6px;
  color: #1e2a44;
  font-size: 24px;
  white-space: nowrap;
}

.pricePopup-subtitle {
  color: #5f6f8b;
  font-size: 14px;
}

.pricePopup-top > div:first-child {
  flex: 0 0 auto;
  min-width: 230px;
}

.pricePopup-actions {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex: 1 1 auto;
}

.pricePopup-field {
  min-width: 170px;
}

.pricePopup-field label {
  display: block;
  margin-bottom: 6px;
  color: #4b587c;
  font-size: 13px;
  font-weight: 700;
}

.pricePopup-apply {
  min-height: 46px;
  padding: 0 20px;
  border-radius: 14px;
  font-weight: 700;
}

.priceTableWrap {
  overflow: auto;
  max-height: calc(100vh - 300px);
  border: 1px solid #dfe5ec;
  border-radius: 22px;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7), 0 10px 24px rgba(15, 23, 42, 0.06);
}

.priceTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.priceTable thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f6 100%);
  color: #4b587c;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 14px 16px;
  border-bottom: 1px solid #dfe5ec;
}

.priceTable tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
  background: rgba(255, 255, 255, 0.9);
}

.priceTable tbody tr:last-child td {
  border-bottom: 0;
}

.priceTable-check {
  width: 52px;
  text-align: center;
}

.redColor {
  color: red
}
.greenColor {
  color: green;
}
.grayColor {
  color: #CCC;
}
.editMode {
  float: left;
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}
.editMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.lightMode {
  padding: 1%;
  margin-bottom: 1px;
  border-radius: 10px;
  margin-left: 1px !important;
  margin-right: 1px !important;
  background-color: #F2F2F2;
  padding-left: 1px !important;
  padding-right: 1px !important;
  font-size: 11px;
}

.lightSearchBar {
  margin: 0 0 14px;
  padding: 14px 16px 10px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe4f0;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.lightSearchBar-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.lightSearchBar-title {
  color: #1e2a44;
  font-size: 15px;
  font-weight: 700;
}

.lightSearchBar-count {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.lightCatalogCard {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe4f0;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.08);
}

.lightCatalogAction {
  width: 46px;
  height: 46px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);
  color: #fff;
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  flex: 0 0 auto;
}

.lightCatalogAction:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(37, 99, 235, 0.28);
}

.lightCatalogThumb {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dde7f2;
  flex: 0 0 auto;
}

.lightCatalogThumbImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lightCatalogBody {
  flex: 1 1 auto;
  min-width: 0;
}

.lightCatalogTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.lightCatalogRef {
  color: #71829c;
  font-size: 12px;
  line-height: 1.4;
  word-break: break-word;
}

.lightCatalogKind {
  padding: 4px 8px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.lightCatalogTitle {
  color: #1e2a44;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
}

.lightCatalogMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.lightCatalogMeta span {
  padding: 5px 9px;
  border-radius: 999px;
  background: #eef3f8;
}

.lightCatalogPrice {
  flex: 0 0 auto;
  min-width: 96px;
  padding: 10px 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, #ecfeff 0%, #dff7fb 100%);
  border: 1px solid #bfe7f3;
  text-align: right;
}

.lightCatalogPriceLabel {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.lightCatalogPriceValue {
  color: #1e2a44;
  font-size: 18px;
  font-weight: 700;
  margin-top: 4px;
}
.serviceGridItem {
  min-height: 100%;
  margin-bottom: 22px !important;
}

.serviceGridItem > .row {
  position: relative;
  min-height: 100%;
  padding-top: 6px;
}

.serviceGridItem .row > [class^="col-md-"] {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
}

.serviceGridItem .col-md-1:first-child {
  align-items: flex-start;
  margin-bottom: 10px;
}

.serviceGridItem .pic {
  width: 88px !important;
  height: 88px !important;
}

.serviceGridItem .pic img {
  width: 88px !important;
  height: 88px !important;
}

.serviceGridItem .col-md-4,
.serviceGridItem .col-md-2,
.serviceGridItem .col-md-3 {
  margin-bottom: 10px;
  gap: 6px;
  padding: 12px 14px !important;
  border-radius: 16px;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f7fb 100%);
  border: 1px solid #e7edf5;
}

.serviceGridItem .col-md-4 > b {
  font-size: 18px;
  line-height: 1.18;
}

.serviceGridItem .col-md-2,
.serviceGridItem .col-md-3 {
  align-items: flex-start !important;
}

.serviceGridItem .col-md-4 > em:first-child {
  font-size: 13px !important;
}

.serviceGridItem .col-md-4 > em:last-child {
  font-size: 12px !important;
  line-height: 1.35;
}

.serviceGridItem .col-md-2,
.serviceGridItem .col-md-3 {
  font-size: 13px;
}

.serviceGridItem .col-md-3 b {
  font-size: 15px;
}

.serviceGridItem .col-md-2:last-child {
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
  max-width: none;
  margin-bottom: 0;
}

.serviceGridItem .menu {
  width: auto;
  max-width: 172px;
  justify-content: flex-end;
}
.listeMode .row,
.editMode .row {
  min-height: 120px;
}

.listeMode .col-md-4,
.editMode .col-md-4 {
  gap: 8px;
}

.listeMode .col-md-4 > em:first-child,
.editMode .col-md-4 > em:first-child {
  font-size: 16px !important;
  color: #7b879c;
}

.listeMode .col-md-4 > b,
.editMode .col-md-4 > b {
  font-size: 22px;
  line-height: 1.08;
  color: #1e2a44;
}

.listeMode .col-md-4 > em:last-child,
.editMode .col-md-4 > em:last-child {
  font-size: 13px !important;
  line-height: 1.45;
}

.listeMode .col-md-2,
.listeMode .col-md-3,
.editMode .col-md-2,
.editMode .col-md-3 {
  font-size: 15px;
}

.listeMode .col-md-3 b,
.editMode .col-md-3 b {
  font-size: 17px;
}
.listeMode {
  padding: 1%;
  margin-bottom: 10px;
  border-radius: 10px;
  min-height: 40px;
  background-color: #fff;
}

.listeMode .menu {
  float: right;
  border-radius: 10px;
  background-color: #fff;
}
.pic {
  width: 17%;
  margin-right: 3%;
  float: left;
}
.pic img {
  border-radius: 50%;
}
.preview {
  float: left;
  font-weight: bolder;
}

.preview em {
  font-weight: lighter;
  font-size: 12px;
}

.flowted {
  filter: blur(3.5px);
}

.actif {
  filter: none;
  background-color: #131016;
}

.shop {
  margin-right: 5px;
  color: #2bffc6;
}
.service {
  margin-right: 5px;
  color: #ff8d72;
}
.lubrifiant {
  margin-right: 5px;
  color: #ffd600;
}

.mainPanelWithoutFilter {
  margin-top: 100px;
}

.subMenu {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    min-height: 40px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

.alwaysBlueAddButton,
.alwaysBlueAddButton:hover,
.alwaysBlueAddButton:focus,
.alwaysBlueAddButton:active,
.alwaysBlueAddButton:not(:disabled):not(.disabled):active,
.alwaysBlueAddButton:not(:disabled):not(.disabled).active,
.show > .alwaysBlueAddButton.dropdown-toggle {
  background: linear-gradient(135deg, #1d8cf8 0%, #3358f4 100%) !important;
  border-color: #3358f4 !important;
  color: #ffffff !important;
  box-shadow: 0 10px 24px rgba(29, 140, 248, 0.28) !important;
}
  .pageHeader {
    position: fixed;
    top: 120px;
    left: 0;
    width: 100%;
    z-index:333;
    background: #f2f2f2;
    overflow: visible;
  }
  .pageHeader.row,
  .subMenu.row,
  .lightHeader.row {
    margin-left: 0;
    margin-right: 0;
  }

  .pageHeader .serachPanel {
    position: fixed;
  top: 119px;
    right: 0;
    width: min(420px, calc(100vw - 36px));
    height: calc(100vh - 148px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0;
    box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
    border: 1px solid #dbe4f0;
    z-index: 334;
    font-size: 14px;
    animation: filterPanelReveal 0.24s ease;
  }
  .pageHeader .serachPanel.row {
    margin-left: 0;
    margin-right: 0;
  }
  .pageHeader .serachPanel [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 0 10px;
  }
  .filterPanelHeader {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e2e8f0;
  }
  .filterPanelTitle {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
  }
  .filterPanelCount {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }
  .filterCloseBtn {
    background: #1f2a44;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    padding: 7px 14px;
  }
  .filterQuickTools {
    padding: 14px !important;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
  border-radius: 0;
    margin-bottom: 8px;
  }
  .filterQuickTitle {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #475569;
    margin-bottom: 10px;
    letter-spacing: 0.04em;
  }
  .pageHeader .serachPanel .form-control,
  .pageHeader .serachPanel .custom-select {
    width: 100%;
    min-height: 46px;
    font-size: 15px !important;
    border-radius: 12px;
  }
  .pageHeader .serachPanel [class*="col-"] {
    font-size: 15px;
  }
  .pageHeader .serachPanel .col-md-1 {
    font-size: 13px !important;
    line-height: 1.6;
  }

@keyframes filterPanelReveal {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

  .lightHeader {
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  .lightHeader .serachPanel {
    font-size: 11px;

  }

  .lightHeader .serachPanel .form-control  {
    font-size: 11px !important;
    padding: 3px !important;
  }

@media (max-width: 768px) {
  .lightSearchBar {
    padding: 12px;
  }

  .lightSearchBar-meta {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .lightCatalogCard {
    padding: 12px 14px;
    gap: 12px;
    align-items: flex-start;
  }

  .lightCatalogAction {
    width: 42px;
    height: 42px;
  }

  .lightCatalogThumb {
    width: 54px;
    height: 54px;
  }

  .lightCatalogTop {
    flex-direction: column;
    align-items: flex-start;
  }

  .lightCatalogPrice {
    min-width: 84px;
    text-align: left;
  }

  .pricePopup-top,
  .pricePopup-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .pricePopup-field {
    min-width: 0;
    width: 100%;
  }

  .pricePopup-apply {
    width: 100%;
  }

  .pageHeader {
    top: 50px;
  }

  .subMenu {
    padding: 6px 10px;
    justify-content: center;
  }

  .pageHeader .serachPanel {
    top: 119px;
    right: 0;
    width: calc(100vw - 20px);
    height: calc(100vh - 108px);
    padding: 12px;
  }

  .mainPanelWithoutFilter {
    margin-top: 110px;
  }
}
</style>

